export default {
  // 入场时间段配置
  insertWlVehicleTimeslot: '/ygsjzs/wlVehicleTimeslot/insertWlVehicleTimeslot',
  updateWlVehicleTimeslot: '/ygsjzs/wlVehicleTimeslot/updateWlVehicleTimeslot',
  deleteDataWlVehicleTimeslot: '/ygsjzs/wlVehicleTimeslot/deleteDataWlVehicleTimeslot',
  selectWlVehicleTimeslotBySlotId: '/ygsjzs/wlVehicleTimeslot/selectWlVehicleTimeslotBySlotId',
  selectWlVehicleTimeslotByPage: '/ygsjzs/wlVehicleTimeslot/selectWlVehicleTimeslotByPage',
  selectWlVehicleTimeList: '/ygsjzs/wlVehicleTimeslot/selectWlVehicleTimeList',
  // 入场计划
  // 单据下载统一使用POST JSON，服务端生成PDF并记录本次下载。
  exportDocument: '/ygsjzs/wlVehiclePlan/exportDocument',
  insertWlVehiclePlan: '/ygsjzs/wlVehiclePlan/insertWlVehiclePlan',
  editWlVehiclePlan: '/ygsjzs/wlVehiclePlan/editWlVehiclePlan',
  editMwWlVehiclePlan: '/ygsjzs/wlVehiclePlan/editMwWlVehiclePlan',
  updateWlVehiclePlan: '/ygsjzs/wlVehiclePlan/updateWlVehiclePlan',
  deleteDataWlVehiclePlan: '/ygsjzs/wlVehiclePlan/deleteDataWlVehiclePlan',
  selectWlVehiclePlanByPlanId: '/ygsjzs/wlVehiclePlan/selectWlVehiclePlanByPlanId',
  selectWlVehiclePlanByPage: '/ygsjzs/wlVehiclePlan/selectWlVehiclePlanByPage',
  selectWlVehicleDayByList2: '/ygsjzs/wlVehiclePlan/selectWlVehicleDayByList2',
  editWlVehiclePlanQx: '/ygsjzs/wlVehiclePlan/editWlVehiclePlanQx',
  // 退回物流计划
  bakeWlVehiclePlan: '/ygsjzs/wlVehiclePlan/bakeWlVehiclePlan',
  // 确认车辆出场
  editMwWlVehiclePlanCc: '/ygsjzs/wlVehiclePlan/editMwWlVehiclePlanCc',
  // 计划配置
  insertWlVehicleDate: '/ygsjzs/wlVehicleDate/insertWlVehicleDate',
  updateWlVehicleDate: '/ygsjzs/wlVehicleDate/updateWlVehicleDate',
  deleteDataWlVehicleDate: '/ygsjzs/wlVehicleDate/deleteDataWlVehicleDate',
  selectWlVehicleDateByDateId: '/ygsjzs/wlVehicleDate/selectWlVehicleDateByDateId',
  selectWlVehicleDateByPage: '/ygsjzs/wlVehicleDate/selectWlVehicleDateByPage',
  // 订餐统计
  selectWlVehicleMealByList: '/ygsjzs/wlVehiclePlan/selectWlVehicleMealByList',
  // 查询车辆入场的规格清单
  selectWlVehiclePlanGg: '/ygsjzs/wlVehiclePlan/selectWlVehiclePlanGg',
  selectWlVehiclePlanGg1: '/ygsjzs/wlVehiclePlan/selectWlVehiclePlanGg1',
  // 物流统计
  selectWlVehicleInfoCount: '/ygsjzs/wlVehiclePlan/selectWlVehicleInfoCount',
  // 开始装货
  editCYWlVehiclePlanZh: '/ygsjzs/wlVehiclePlan/editCYWlVehiclePlanZh',
  // 结束装货
  editMwWlVehiclePlanZhWc: '/ygsjzs/wlVehiclePlan/editMwWlVehiclePlanZhWc'
}
